import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Freundvereine extends Component {
  render() {
    return (
      <section id="friends">
        <h1>Befreundete Vereine</h1>
        <div className="row no-bottom-margin">
          <section className="col">
            <h2>Musikverein Sueng</h2>
            <a href="http://www.musikverein-sueng.de/">
              <img
                src={require("./images/vereine/logosueng.png")}
                alt="Musikverein Sueng"
              />
            </a>
          </section>
          <section className="col mid">
            <h2>Blasorchester MV - Thier 1900 e.V.</h2>
            <a href="http://www.mv-thier.de/">
              <img
                src={require("./images/vereine/mv_logo_small.png")}
                alt="Blasorchester MV - Thier 1900 e.V."
              />
            </a>
          </section>
          <section className="col">
            <h2>Musikverein Wipperf&uuml;rth 1853 e.V.</h2>
            <a href="http://www.mvwipperfuerth.de/">
              <img
                src={require("./images/vereine/wappen_klein.gif")}
                alt="Musikverein Wipperf&uuml;rth 1853 e.V."
              />
            </a>
          </section>
        </div>
        <div className="row no-bottom-margin">
          <section className="col">
            <h2>Schützenkapelle Kreuzberg</h2>
            <a href="http://www.schuetzenkapelle-kreuzberg.de/">
              <img
                src={require("./images/vereine/Kreuzberg.png")}
                alt="Schützenkapelle Kreuzberg"
              />
            </a>
          </section>
          <section className="col mid">
            <h2>Musikverein Linde</h2>
            <a href="https://www.musikverein-linde.de/">
              <img
                src="https://image.jimcdn.com/app/cms/image/transf/dimension=619x10000:format=png/path/s21f2eda3d302a042/image/idc953bd5d815a4d9/version/1465996389/image.png"
                className="linde-logo"
                alt="Musikverein Linde"
              />
            </a>
          </section>
          <section className="col">
            <h2>Musikverein Frielingsdorf</h2>
            <a href="http://mvf1856.de/">
              <img
                src={require("./images/vereine/Frielingsdorf.png")}
                alt="Musikverein Frielingsdorf"
              />
            </a>
          </section>
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Freundvereine;



// WEBPACK FOOTER //
// ./src/components/freundvereine.js